import { useEffect, useState } from 'react'

const STORAGE_KEY = 'seldon.sidebar.collapsed'

/** A browser preference only; changing navigation never writes to the user's profile. */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
      return false
    }
  })
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(collapsed))
    } catch {
      /* Still works for this visit. */
    }
  }, [collapsed])
  return [collapsed, setCollapsed] as const
}
